import { defineStore } from 'pinia'
import { useTenantGetListOfCurrentUser } from '@/models/tenant'

type State = {
  user: AuthUser,
  authenticated: -1 | 0 | 1, // 0 = false, 1 = true, -1 = unknown
  tenants: TenantInit[],
  tenantSelected: number | null,
}

const tenantLocalStorage = 'tenant-selected'

export const useAuthStore = defineStore('Auth', {
  state: (): State => ({
    user: {
      id: 0,
      name: '',
      email: '',
    },
    tenants: [],
    authenticated: -1,
    tenantSelected: null,
  }),
  getters: {
    tenantNameSelected (state) {
      return state.tenants.find((p) => p.id === state.tenantSelected)?.name ?? 'Pilih Tenant'
    },
  },
  actions: {
    async reloadTenant () {
      const { getData } = useTenantGetListOfCurrentUser()
      const tenants = await getData()
      this.tenants = tenants

      if (this.tenantNameSelected === 'Pilih Tenant') {
        this.initTenantSelected()
      }
    },
    setUser (user: Partial<AuthUser>) {
      this.user = { ...this.user, ...user }
    },
    setAuthenticated (authenticated: -1 | 0 | 1) {
      this.authenticated = authenticated
    },
    canAccess (permission: string, tenantId?: number) {
      if (this.tenants.length === 0 || this.tenantSelected === null) {
        return true
      }

      if (tenantId) {
        const tenant = this.tenants.find((p) => p.id === tenantId)
        if (!tenant) {
          return false
        }

        return tenant.permissions
          .map((p) => p.toLowerCase())
          .includes(permission.toLowerCase())
      }
      const tenant = this.tenants.find((p) => p.id === this.tenantSelected)
      if (!tenant) {
        return false
      }

      return tenant.permissions
        .map((p) => p.toLowerCase())
        .includes(permission.toLowerCase())
    },
    setTenants (data: TenantInit[]) {
      this.tenants = data
    },
    setTenantSelected (tenant: Tenant) {
      localStorage.setItem(tenantLocalStorage, String(tenant.id))
      this.tenantSelected = tenant.id
    },
    initTenantSelected () {
      const tenantSelected = localStorage.getItem(tenantLocalStorage)
      if (tenantSelected) {
        const isExists = this.tenants.find((p) => p.id === Number(tenantSelected))
        if (isExists) {
          this.tenantSelected = Number(tenantSelected)
          return
        }
      }

      this.tenantSelected = this.tenants[0]?.id ?? 0
    },
  },
})
